<app-dropdown
  [autoClose]="'outside'"
  placement="bottom-right"
  container="body"
  (openChange)="onOpenChange($event)"
  #dropdown
>
  <button
    appDropdownButton
    name="favoriteButton"
    class="btn btn-transparent"
    [attr.disabled]="disabled"
  >
    <i
      class="icon fa-star"
      [class.favorite]="favorite"
      [class.fas]="favorite"
      [class.far]="!favorite"
      aria-label="Favorite Menu"
    ></i>
  </button>

  @for (dashboard of dashboards(); track dashboard.id) {
    <button
      appDropdownItem
      name="dashboardFavoriteButton"
      angulartics2On="click"
      angularticsCategory="Chart"
      [angularticsAction]="!isOnDashboard(dashboard.id) ? 'Favorite' : 'Unfavorite'"
      [angularticsLabel]="codename"
      (click)="onFavoriteClick(dashboard)"
    >
      <i
        class="icon fa-star"
        [class.favorite]="isOnDashboard(dashboard.id)"
        [class.fas]="isOnDashboard(dashboard.id)"
        [class.far]="!isOnDashboard(dashboard.id)"
        aria-label="Add To Dashboard"
      ></i>
      <span class="light">{{ favoriteButtonText(dashboard) }}</span>
      <span class="dark">{{ dashboard.name }}</span>
    </button>
  }

  <!-- Create Dashboard Button -->
  @if (!editing) {
    <button
      class="btn create-dashboard"
      name="createDashboard"
      (click)="showCreateDashboardForm()"
      appDropdownItem
    >
      <i class="icon fas fa-plus" aria-label="Create Dashboard"></i>
      <span class="light">Add To New Dashboard</span>
    </button>
  }

  <!-- Create Dashboard Form -->
  @if (editing) {
    <form
      (submit)="onCreateDashboard($event, name.value)"
      class="input-group editing create-dashboard"
      appDropdownItem
    >
      <input
        #name
        name="nameInput"
        class="form-control"
        type="text"
        placeholder="Dashboard Name"
        required
      />
      <div class="input-group-append">
        <button type="submit" class="btn btn-primary" name="createDashboard">Create</button>
      </div>
    </form>
  }
</app-dropdown>
